"use client";
import { useEffect, useRef } from "react";

// replace with @xobotyi/scrollbar-width
import { Platform } from "react-native";
import { getScrollbarWidth } from "../../utils";

function getRightPadding() {
  return parseInt(getComputedStyle(document.body).paddingRight, 10) || 0;
}

function isOverflowing() {
  return window.innerWidth > document.documentElement.clientWidth;
}

export default function useScrollLock(
  active: boolean,
  documentId = "screenWrapper"
) {
  const prevActive = useRef(false);

  useEffect(() => {
    if (Platform.OS !== "web") return;
    if (active && !prevActive.current) {
      const restore: Array<{
        property: string;
        el: HTMLElement;
        value: string;
      }> = [];

      // This is to add a padding to the right if the user has a scrollbar
      // and to prevent the body from shifting when the scrollbar is removed
      // when the scroll is locked.
      if (isOverflowing()) {
        restore.push({
          value: document.body.style.paddingRight,
          property: "padding-right",
          el: document.body,
        });

        const rightPadding = getRightPadding() + getScrollbarWidth();
        document.body.style.paddingRight = `${rightPadding}px`;
      }

      const documentWrapper = document.getElementById(documentId || "");
      if (documentWrapper) {
        restore.push({
          value: "auto",
          property: "overflow",
          el: documentWrapper,
        });

        documentWrapper.style.overflow = "hidden";
      } else {
        if (window.screen.width > 1240) {
          restore.push({
            value: "auto",
            property: "overflow",
            el: document.body,
          });
          document.body.style.overflow = "hidden";
        } else {
          restore.push({
            value: "auto",
            property: "overflowY",
            el: document.body,
          });
          document.body.style.overflowY = "hidden";
        }
      }

      // Lock the scroll on the html element
      const html = document.documentElement;
      restore.push({
        value: "auto",
        property: "overflow",
        el: html,
      });
      html.style.overflowY = "hidden";

      return () => {
        restore.forEach(({ value, property, el }) => {
          if (value) {
            el.style.setProperty(property, value);
          } else {
            el.style.removeProperty(property);
          }
        });
      };
    }

    prevActive.current = active;

    return;
  }, [active]);
}
